(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const revealAll = (targets) => {
    targets.forEach((element) => element.classList.add("is-visible"));
  };

  const bind = (root = document) => {
    const targets = [...root.querySelectorAll("[data-sf-reveal]")].filter(
      (element) => !element.dataset.sfRevealBound,
    );
    targets.forEach((element) => {
      element.dataset.sfRevealBound = "true";
    });

    if (reduceMotion.matches || !("IntersectionObserver" in window)) {
      revealAll(targets);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
    );
    targets.forEach((element) => observer.observe(element));
  };

  document.documentElement.classList.add("sf-motion-ready");
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bind(), { once: true });
  } else {
    bind();
  }
  document.addEventListener("shopify:section:load", (event) => bind(event.target));
})();
